import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../services';

@Injectable({
  providedIn: 'root'
})
export class CompanyRestaurantGuard  {
  constructor(private router: Router, private auth: AuthService) {}

  canActivate(): boolean {
    return this.checkAuthorization();
  }

  private checkAuthorization(): boolean {

    if (this.auth.getIsCompanyAdmin()) {
      this.router.navigate(['pages/dashboard']);
      return true;
    }

    if (this.auth.getIsRestaurantAdmin()) {
      this.router.navigate(['pages/restaurant_dashboard']);
      return true;
    }

    if (this.auth.getIsAdmin()) {
      this.router.navigate(['pages/admin_common']);
      return true;
    }

    return false;
  }
}
